import { render, staticRenderFns } from "./CountsTable.vue?vue&type=template&id=eedc2240&scoped=true&"
import script from "./CountsTable.vue?vue&type=script&lang=js&"
export * from "./CountsTable.vue?vue&type=script&lang=js&"
import style0 from "./CountsTable.vue?vue&type=style&index=0&id=eedc2240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedc2240",
  null
  
)

export default component.exports